"use client";
import "@/styles/carousel-base.css";
import { MangoBlockProps } from "@/types/general";
import CoverageSide from "./CoverageSide";
import ReadingSide from "./StoryDetails";
import SideBarTabs from "./SideBarTabs";
import { useRelatedPosts } from "@pulsex/hooks";
import pulseConfig from "@/pulsex.config";
import { Post } from "@pulsex/types";
import { usePathname } from "next/navigation";

export default function DetailsGroup({ block, pagePostId }: MangoBlockProps) {
    const pathname = usePathname();
    const isNewsDetailsPage = pathname.includes("/news/");
    let storyDetailsWidget = block?.getMainWidgetByStyle(
        "Details/StoryDetails"
    );
    
    let coverage = block?.getMainWidgetByStyle("Details/Coverage");
    let TrendingStory = block?.getWidgetsByStyle("Details/SidebarTabItems");
    let mainPost = storyDetailsWidget?.posts[0];
    const relatedPostsQ = useRelatedPosts({
        config: pulseConfig,
        postId: pagePostId,
        size: 2,
        enabled: isNewsDetailsPage
    });
    // below we're mapping the related posts and removing the domain that is coming from the api 'alpha-en-media...'
    // because we dont need it as we already have a post mapper that prepends a media url to post images
    const relatedPosts = relatedPostsQ?.posts?.map(p => ({
        ...p,
        image: p.image.replace('https://alpha-en-media.almayadeen.net/', '')
    }) as Post);
    if (!block) return null;

    return (
        <div>
            <div className="container mx-auto mb-10 grid grid-cols-4 gap-4 lg:mb-5">
                <div className="col-span-3 lg:col-span-4">
                    <h1 className="font-bold text-4xl dark:text-white mt-6 mb-3 lg:text-xl lg:mb-0 lg:font-black lg:mt-3">
                        {mainPost?.title}
                    </h1>
                    {storyDetailsWidget && (
                        <ReadingSide
                            widget={storyDetailsWidget}
                            relatedPosts={relatedPosts}
                        />
                    )}
                </div>
                <div className="col-span-1 lg:hidden pt-6 h-full flex flex-col">
                    <SideBarTabs widget={TrendingStory} />
                    <CoverageSide widget={coverage} />
                </div>
            </div>
        </div>
    );
}
